import { HttpEvent, HttpRequest, HttpHandlerFn, HttpResponse } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthStepEnum } from '@lentau/auth/shared';
import { AuthFacade } from '@lentau/auth/store';
import { ResponseErrorListItemProps } from '@lentau/api/shared/monolith/types';
import { ResponseCodeEnum } from '../shared/enums';

enum ErrorCodesEnum {
  Unauthorized = 21,
}

export function logoutInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const injector: Injector = inject(Injector);
  return next(req).pipe(
    switchMap((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) {
        return handleLogoutInterceptor(event, injector);
      } else {
        return of(event);
      }
    })
  );
}

export function handleLogoutInterceptor(
  event: HttpResponse<unknown>,
  injector: Injector
): Observable<HttpEvent<unknown>> {
  const authFacade: AuthFacade = injector.get(AuthFacade);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const body: any = event.body;

  if (body && shouldGeneralFailureBeIntercepted(body)) {
    handleUnauthorized(body, authFacade);
    return throwError(() => body.Body.ErrorList as ResponseErrorListItemProps[]);
  }

  return of(event);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function shouldGeneralFailureBeIntercepted(body: any): boolean {
  return body?.Head?.Status === ResponseCodeEnum.failure;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function handleUnauthorized(body: any, authFacade: AuthFacade): void {
  if (shouldUnauthorizedBeIntercepted(body)) {
    if (authFacade.isAuth()) {
      authFacade.logoutSuccess();
    }
    authFacade.setAuthStep(AuthStepEnum.LOGIN_BY_PHONE);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function shouldUnauthorizedBeIntercepted(body: any): boolean {
  return body?.Body?.ErrorList?.some(
    (errorListItem: { Code: number }) => errorListItem.Code === ErrorCodesEnum.Unauthorized
  );
}
